import { useState } from "react";
import { motion } from "framer-motion";

const fmt = (n) => n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const AssayPanel = ({ assay, testid }) => {
  const [sel, setSel] = useState(0);
  const r = assay.readings[sel];
  const maxPct = Math.max(...assay.readings.map((x) => x.max ?? x.pct));

  return (
    <div data-testid={testid} className="card-line bg-[#0A0A0B]">
      <div className="px-6 py-4 hairline-b flex items-center justify-between">
        <span className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#C9A227]">{assay.instrument}</span>
        <span className="w-1.5 h-1.5 rounded-full bg-[#C9A227] animate-pulse" aria-hidden="true" />
      </div>

      <div className="px-6 py-8 bg-[#121215] text-center">
        <div className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-zinc-400 mb-3">{assay.sample}</div>
        <div className="font-mono2 text-5xl sm:text-6xl text-[#E8C85A] tabular-nums" data-testid={`${testid}-readout`}>
          {r.min != null ? `${r.min}–${r.max}` : fmt(r.pct)}
          <span className="text-2xl text-[#C9A227]">%</span>
        </div>
        <div className="mt-2 font-mono2 text-[12px] uppercase tracking-[0.2em] text-zinc-400">{r.el}</div>
        {r.sigma != null && (
          <div className="mt-1 font-mono2 text-[11px] text-zinc-400 tabular-nums">±2σ {fmt(r.sigma)}</div>
        )}
        {assay.karat && (
          <div className="mt-4 inline-block px-4 py-1.5 card-line font-mono2 text-[11px] tracking-[0.2em] text-[#D4AF37] uppercase" data-testid={`${testid}-karat`}>
            Karat {fmt(assay.karat.value)} ± {fmt(assay.karat.sigma)}
          </div>
        )}
      </div>

      <div className="px-6 py-5 space-y-3">
        {assay.readings.map((x, i) => {
          const val = x.max ?? x.pct;
          const lo = x.min ?? 0;
          return (
            <button
              key={i}
              type="button"
              data-testid={`${testid}-row-${i}`}
              onClick={() => setSel(i)}
              aria-pressed={sel === i}
              className={`w-full text-left px-3 py-2 transition-colors ${sel === i ? "bg-[#1C1C22]" : "hover:bg-[#16161A]"}`}
            >
              <div className="flex justify-between font-mono2 text-[11px] uppercase tracking-[0.15em] mb-1.5">
                <span className={sel === i ? "text-[#E8C85A]" : "text-zinc-400"}>{x.el}</span>
                <span className="text-zinc-400 tabular-nums">
                  {x.min != null ? `${x.min}–${x.max}%` : `${fmt(x.pct)}%${x.sigma != null ? ` ±${fmt(x.sigma)}` : ""}`}
                </span>
              </div>
              <div className="h-1.5 bg-[#1C1C22] relative overflow-hidden">
                <motion.div
                  className="absolute inset-y-0 left-0 bg-gradient-to-r from-[#997A19] to-[#D4AF37]"
                  initial={{ width: 0 }}
                  whileInView={{ width: `${(val / maxPct) * 100}%` }}
                  viewport={{ once: true }}
                  transition={{ duration: 1, delay: 0.15 * i, ease: [0.22, 1, 0.36, 1] }}
                  style={x.min != null ? { left: `${(lo / maxPct) * 100}%`, width: undefined } : undefined}
                />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
